var prop = require('mithril/stream')
var loaders = require('../../layout/components/loaders');

var session = {};

session.user = prop(false);
session.next = prop('/');

function parseRoleFlag(value) {
  if (value === true || value === 1) return 1;
  if (typeof value === 'string') {
    return value === '1' ? 1 : 0;
  }
  return 0;
}

session.logout = function () {
  return loaders.requestWithLoader({
    method: 'GET',
    url: '/api/v1/user/logout/',
  })
}
session.getUser = function (rid) {
  return loaders.requestWithLoader({
    loader: 'main',
    method: 'GET',
    responseType: 'json',
    url:'/api/v1/user/' + rid.slice(1)
  }).then(function (data) {
    var u = data;
    u.unitMap = {
      'tempC': 'tempF',
      'temp-C': 'temp-F',
      'degC': 'degF',
      'Pa': 'inH2O',
      'kPa': 'inH2O',
      'L/s': 'gal/min'
    };

    session.user(u);
    if (session.user()) {
      session.user().isSuperuser = parseRoleFlag(session.user().isSuperuser);
      session.user().isReportAdmin = parseRoleFlag(session.user().isReportAdmin);
      session.user().isDeveloper = parseRoleFlag(session.user().isDeveloper);
    }
    return u;
  })
}

session.isSuperuser = function () {
  var user = session.user();
  return !!(user && parseRoleFlag(user.isSuperuser));
}

session.isReportAdmin = function () {
  var user = session.user();
  return !!(user && parseRoleFlag(user.isReportAdmin));
}

session.isDeveloper = function () {
  var user = session.user();
  return !!(user && parseRoleFlag(user.isDeveloper));
}

session.canManageScheduledReports = function () {
  return session.canManageReports();
}

session.canManageReports = function () {
  return session.isSuperuser() || session.isReportAdmin();
}

session.listUsers = function () {
  return loaders.requestWithLoader({
    method: 'GET',
    url: '/api/v1/user/'
  })
}

session.listGroups = function () {
  return loaders.requestWithLoader({
    method: 'GET',
    url: '/api/v1/group/'
  })
}

module.exports = session;
